import React from "react";

const HomePage = () => {
  return <React.Fragment></React.Fragment>;
};

export default HomePage;
